import React from 'react'

// The white/red C3 monogram, used on the landing page in the hero badge,
// the factsheet banner and the footer.
function C3Mark({ width = 114, height = 190, className }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 114 190"
      fill="none"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.0603 0L0.537109 25.2426V190H66.6808L93.0277 164.756V151.844H66.6808V164.756H13.9852L26.884 152V25.2426H66.6808V37.9969H93.0277V0H26.0603Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M73.4419 46.1582L66.8426 52.7892V59.2791H98.7171V86.7903H86.0801L78.7776 93.4207V100.052H99.9812V131.795H72.7399L66.1406 138.284V144.915H100.403L113.461 131.795V98.9234L107.143 92.7154L111.776 88.0598V46.1582H73.4419Z"
        fill="#D50021"
      />
    </svg>
  )
}

export default C3Mark
